import "./styles.css";
import {ThemeProvider} from '@mui/material/styles'
import { useRef, useState, useEffect  } from 'react';

import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import Intro from "./components/Intro.js";
import Home from "./components/Home.js";
import { useDispatch, useSelector } from "react-redux";
import theme from "./components/theme.js";
import { ImageBackground, SafeAreaView ,StyleSheet, Text, View } from 'react-native';

import jwt_decode from "jwt-decode";

import actions from "./components/actions";

function App() {
  const image = { uri: "https://metaero.org/background.jpg" };


  const hi = useSelector((state) => state.heightInfo);
  const heightfixed = useSelector((state) => state.windowHeightInfo);

  const dispatch = useDispatch();


  useEffect(() => {
    dispatch({
      type: actions.SET_WINDOW_HEIGHT_FIXED,
      payload: window.innerHeight
    });

    const handleWindowResize = () => {

      dispatch({
        type: actions.SET_WINDOW_HEIGHT_FIXED,
        payload: window.innerHeight
      });

    };
    window.addEventListener('resize', handleWindowResize);

    return () => {


      window.removeEventListener('resize', handleWindowResize);
    };


  }, []);

  return (
    <BrowserRouter>
     <ThemeProvider theme={theme}>
     <SafeAreaView>
    {/*<ImageBackground style={{width: '100%', height: heightfixed.result*1.4 }} resizeMode="cover" source={image} imageStyle=
{{opacity:0.8}}>*/}
    <body>
    <div style={{minHeight: heightfixed.result}} id="mainapp" className="App">
      <Home />
     </div>
    </body>

    {/*</ImageBackground>*/}
     </SafeAreaView>
    </ThemeProvider>
    </BrowserRouter>
  );
}
export default App;

//416913523020-skl8c263bg31buo05lh3cj6sc02560k0.apps.googleusercontent.com

//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
